module.exports = __webpack_public_path__ + "img/watching-movie.6da2dde6.svg";